
// Helper function to get tokens from localStorage
export const getLocalStorageKey = (key: string): string | null => localStorage.getItem(key);

// Helper function to set tokens in localStorage
export const setLocalStorageKey = (key: string, value: string): void => localStorage.setItem(key, value);

// Helper function to remove a token from localStorage (optional)
export const removeLocalStorageKey = (key: string): void => localStorage.removeItem(key);
